var map = {
	"./ClickHand.png": "9269",
	"./Eligibility.png": "619b",
	"./HappyMan.png": "d21e",
	"./MobileTab.png": "6dcb",
	"./Rupee.png": "017c",
	"./ezcred_logo_white.png": "3e57",
	"./logo_icon.png": "e732"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";